import React from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  label?: string;
  hint?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error, label, hint, className, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'w-full h-10 px-3 text-sm text-gray-900 bg-white border-2 rounded-md transition-colors duration-150',
            'placeholder:text-gray-400',
            'focus:outline-none focus:border-blue-500',
            'disabled:opacity-50 disabled:bg-gray-50',
            error ? 'border-amber-400' : 'border-gray-200',
            className
          )}
          {...props}
        />
        {hint && (
          <p className={cn('mt-1 text-xs', error ? 'text-amber-600' : 'text-gray-500')}>{hint}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'FlatInput';

export { Input };
export type { InputProps };
